export default __webpack_public_path__ + "static/media/steam.b9f0604e.svg";